import { FETCH_ALL_PRODUCTS, FETCH_PRODUCT } from "../types";
import fetchService from "../../../services/fetchService";

const baseUrl = {
  backend: process.env.API_BASE_URL,
};

export const fetchProductsData = (page) => async (dispatch) =>
  await dispatch({
    type: FETCH_ALL_PRODUCTS,
    message: `All products data`,
    payload: fetchService(`${baseUrl.backend}/api/products?page=${page}`),
  });

export const fetchProductData = (id) => async (dispatch) =>
  await dispatch({
    type: FETCH_PRODUCT,
    message: `All product data`,
    payload: fetchService(`${baseUrl.backend}/api/products/${id}`),
  });
